import { urlConfig } from "../../config/urlConfig";
import { postCall, postFileDownloadCall } from "../httpService";

const GetHelp = urlConfig.GetHelp;
const GetPdf = urlConfig.GetPdf;

export const getHelpData = async (params: any) => {
  try {
    const response = await postCall(GetHelp, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getPdf = async (params: any) => {
  try {
    const response = await postFileDownloadCall(GetPdf, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
